import { Router } from '@angular/router';
import { ROUTES } from '@experience/shop/cart/constants/cart-review.constants';
import { Injectable } from '@angular/core';
import { CartSupportService } from '@support/cart-support/services/cart-support.service';

@Injectable()
export class cartAuthenticationGuard {
  constructor(
    private router: Router,
    private cartSupportService: CartSupportService
  ) {}
  canActivate(): boolean {
    const cart = this.cartSupportService.getStatestoreCartReference();
    const customerSelection = sessionStorage.getItem('customerSelection');
    if (!customerSelection) {
      return true;
    } else if (cart && cart.lines && cart.lines.length == 0) {
      if (cart.devices && cart.devices.length) {
        return true;
      } else if (cart.accessories && cart.accessories.length) {
        return true;
      }
    }
    this.router.navigate([ROUTES.ACCOUNT_SETUP]);
    return false;
  }
}
